import FEEDBACK_CONSTANTS from '@/constants/feedbackConstants';

export default {
  heading: 'Thank you for your assessment!',
  text: 'Is there anything we can improve? Share your opinion with us.',
  form: {
    fields: [
      {
        type: 'textarea',
        name: FEEDBACK_CONSTANTS.FEEDBACK_NAME,
        placeholder: 'Your opinion...'
      }
    ],
    submit: {
      label: 'Send'
    }
  }
};
